var _defs, _path, _mask, _g, _g2, _path2, _mask2, _g3, _path3, _path4, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirst(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 184,
    height: 205.02635717500016,
    viewBox: "0 0 184 205.02635717500016",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_0",
    x1: "76.7823015%",
    y1: "88.0621668%",
    x2: "22.15741600000001%",
    y2: "14.031911099999995%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFAA00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC45",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path_0",
    transform: "translate(0 0) rotate(0 92 102.51317858750001)",
    d: "M87.08,203.73C90.13,205.46 93.87,205.46 96.92,203.73L178.92,157.38C182.06,155.61 184,152.28 184,148.68L184,56.35C184,52.74 182.06,49.42 178.92,47.64L96.92,1.29C93.87,-0.43 90.13,-0.43 87.08,1.29L5.08,47.64C1.94,49.42 0,52.74 0,56.35L0,148.68C0,152.28 1.94,155.61 5.08,157.38L87.08,203.73Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter_13",
    x: 0,
    y: 0,
    width: 119.60948499999958,
    height: 75.75849735000003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_1",
    x1: "50.34973489999999%",
    y1: "113.50610800000001%",
    x2: "49.999999999999986%",
    y2: "2.7049844200000006%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE658",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504971665,
    stopColor: "#F09715",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46701",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path_1",
    transform: "translate(0 0) rotate(0 75.12057730894533 84.55204580875002)",
    d: "M76.6,168.71L148.72,127.77C149.66,127.24 150.24,126.24 150.24,125.16L150.01,44.12C150,42.68 149.23,41.36 147.97,40.65L76.97,0.52C75.75,-0.17 74.25,-0.17 73.03,0.52L2.03,40.65C0.78,41.36 0,42.69 0,44.13L0,124.58C0,126.02 0.77,127.35 2.03,128.06L73.64,168.71C74.56,169.23 75.69,169.23 76.6,168.71Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter_36",
    x: -15,
    y: -15,
    width: 141.2564449361862,
    height: 143.99999987480953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7019607843137254 0 0 0 0 0.043137254901960784 0 0 0 0 0.027450980392156862 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_Shadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_Shadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_2",
    x1: "23.105745699999996%",
    y1: "92.9515865%",
    x2: "104.89564%",
    y2: "56.9152945%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFD944",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAC02",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_3",
    x1: "-1.283880380000002%",
    y1: "74.3613387%",
    x2: "107.7718%",
    y2: "24.157100399999997%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE789",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2D0",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_4",
    x1: "10.9354948%",
    y1: "33.1023114%",
    x2: "84.6407525%",
    y2: "67.2077038%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFD63A",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE331D",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path_2",
    transform: "translate(0 0) rotate(0 46.3277248 49.868215)",
    d: "M46.33,0C20.74,0 0,22.33 0,49.87C0,77.41 20.74,99.74 46.33,99.74C71.91,99.74 92.66,77.41 92.66,49.87C92.66,22.33 71.91,0 46.33,0Z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_5",
    x1: "13.950362599999998%",
    y1: "33.00018930000001%",
    x2: "84.64075249999999%",
    y2: "67.2077038%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FD9B04",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE331D",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter_52",
    x: 73,
    y: 58.50999999999999,
    width: 37,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6509803921568628 0 0 0 0 0.2901960784313726 0 0 0 0 0.011764705882352941 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_Shadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_Shadow",
    result: "shape"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 92 102.51317858750002)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 92 102.51317858750001)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 92 102.51317858750001)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    fillRule: "evenodd",
    fill: "url(#linear_0)",
    transform: "translate(0 0)  rotate(0 92 102.51317858750001)",
    opacity: 1,
    d: "M87.08,203.73C90.13,205.46 93.87,205.46 96.92,203.73L178.92,157.38C182.06,155.61 184,152.28 184,148.68L184,56.35C184,52.74 182.06,49.42 178.92,47.64L96.92,1.29C93.87,-0.43 90.13,-0.43 87.08,1.29L5.08,47.64C1.94,49.42 0,52.74 0,56.35L0,148.68C0,152.28 1.94,155.61 5.08,157.38L87.08,203.73Z "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 92 102.51317858750001)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-0",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-0)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84 1",
    filter: "url(#filter_13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 1",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(-21.275089000000207 -35.444865074999996)  rotate(0 81.0798315 73.32411375000001)",
    opacity: 0.400000006,
    d: "M40.02,146.65L162.16,51.22L122.14,0L0,95.43L40.02,146.65Z "
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(12 13.702635686000008)  rotate(0 80 89.2453254945)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 80 89.2453254945)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path-9",
    fillRule: "evenodd",
    fill: "url(#linear_1)",
    transform: "translate(5 4.4052713714999925)  rotate(0 75.12057730894533 84.55204580875002)",
    opacity: 1,
    d: "M76.6,168.71L148.72,127.77C149.66,127.24 150.24,126.24 150.24,125.16L150.01,44.12C150,42.68 149.23,41.36 147.97,40.65L76.97,0.52C75.75,-0.17 74.25,-0.17 73.03,0.52L2.03,40.65C0.78,41.36 0,42.69 0,44.13L0,124.58C0,126.02 0.77,127.35 2.03,128.06L73.64,168.71C74.56,169.23 75.69,169.23 76.6,168.71Z "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(5 4.4052713714999925)  rotate(0 75.12057730894533 84.55204580875002)"
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-1)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(-12 -2.5947286324999936)  rotate(0 88 88)",
    opacity: 0.219999999,
    d: "M81.61,72.58L37.8,13.75L13.75,37.8L72.58,81.61L0,71L0,105L72.58,94.39L13.75,138.2L37.8,162.25L81.79,103.18L71,176L105,176L94.17,102.89L138.2,162.25L162.25,138.2L102.89,94.16L176,105L176,71L102.89,81.83L162.25,37.8L138.2,13.75L94.34,72.87L105,0L71,0L81.61,72.58Z "
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(33.86457617480528 44.858013404647636)  rotate(0 58.201114368061646 59.499999937404766)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 58.201114368061646 59.499999937404766)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(5.145783799937092 4.999999999999993)  rotate(0 55.6282224680931 56.999999937404766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-12",
    filter: "url(#filter_36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-12",
    fillRule: "evenodd",
    style: {
      fill: "#000000"
    },
    transform: "translate(0 0)  rotate(0 55.6282224680931 56.99999993740476)",
    opacity: 1,
    d: "M98.21,90.48C117.98,65.01 114.94,29.37 91.43,10.88C67.91,-7.62 32.82,-1.96 13.05,23.52C-6.72,48.99 -3.69,84.63 19.83,103.12C43.34,121.62 78.43,115.96 98.21,90.48Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path-12",
    fillRule: "evenodd",
    fill: "url(#linear_2)",
    transform: "translate(0 0)  rotate(0 55.6282224680931 56.99999993740476)",
    opacity: 1,
    d: "M98.21,90.48C117.98,65.01 114.94,29.37 91.43,10.88C67.91,-7.62 32.82,-1.96 13.05,23.52C-6.72,48.99 -3.69,84.63 19.83,103.12C43.34,121.62 78.43,115.96 98.21,90.48Z "
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    fill: "url(#linear_3)",
    transform: "translate(0 0)  rotate(0 55.62822236806163 56.99999993740476)",
    opacity: 1,
    d: "M98.21,90.48C117.98,65.01 114.94,29.37 91.43,10.88C67.91,-7.62 32.82,-1.96 13.05,23.52C-6.72,48.99 -3.69,84.63 19.83,103.12C43.34,121.62 78.43,115.96 98.21,90.48Z "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(8.785919225194831 6.558208220352434)  rotate(0 46.3277248 49.868215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-16",
    fillRule: "evenodd",
    fill: "url(#linear_4)",
    transform: "translate(0 0)  rotate(0 46.3277248 49.868215)",
    opacity: 1,
    d: "M46.33,0C20.74,0 0,22.33 0,49.87C0,77.41 20.74,99.74 46.33,99.74C71.91,99.74 92.66,77.41 92.66,49.87C92.66,22.33 71.91,0 46.33,0Z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 46.3277248 49.868215)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_2"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 3",
    fillRule: "evenodd",
    fill: "url(#linear_5)",
    transform: "translate(3.0874701324391935 5.150376186631824)  rotate(38 46.3277248 49.868215)",
    opacity: 1,
    d: "M46.33,0C20.74,0 0,22.33 0,49.87C0,77.41 20.74,99.74 46.33,99.74C71.91,99.74 92.66,77.41 92.66,49.87C92.66,22.33 71.91,0 46.33,0Z "
  }))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\u6587\\u672C 1",
    filter: "url(#filter_52)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(73 58.50999999999999)  rotate(0 18.5 41)"
  }, /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 63,
    fontSize: 60,
    "line-height": 0,
    fill: "#FFFFFF",
    opacity: 1,
    fontFamily: "AlibabaPuHuiTi-Heavy",
    letterSpacing: 0
  }, "1")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst);
export default __webpack_public_path__ + "static/media/first.5ab0075020ff195c8d62a9de10e21d36.svg";
export { ForwardRef as ReactComponent };